import { Environment } from "@Models/Environment";

export const RADAR_URN: {
  [key in Environment]: string;
} = {
  local: "urn:srf:meteo:mapgroup:1272541977528",
  dev: "urn:srf:meteo:mapgroup:1964459182734",
  int: "urn:srf:meteo:mapgroup:1115951973582",
  "pr-preview": "urn:srf:meteo:mapgroup:1115951973582",
  prod: "urn:srf:meteo:mapgroup:1272541977528",
};
